export const IPCommunicationColors = {
  shade30: '#004578',
  shade20: '#005a9e',
  shade10: '#106ebe',
  primary: '#0078d4',
  tint10: '#2b88d8',
  tint20: '#c7e0f4',
  tint30: '#deecf9',
  tint40: '#eff6fc',
};

export const IPNeutralColors = {
  black: '#000000',
  gray220: '#11100f',
  gray210: '#161514',
  gray200: '#1b1a19',
  gray190: '#201f1e',
  gray180: '#252423',
  gray170: '#292827',
  gray160: '#323130',
  gray150: '#3b3a39',
  gray140: '#484644',
  gray130: '#605e5c',
  gray120: '#797775',
  gray110: '#8a8886',
  gray100: '#979593',
  gray90: '#a19f9d',
  gray80: '#b3b0ad',
  gray70: '#bebbb8',
  gray60: '#c8c6c4',
  gray50: '#d2d0ce',
  gray40: '#e1dfdd',
  gray30: '#edebe9',
  gray20: '#f3f2f1',
  gray10: '#faf9f8',
  white: '#ffffff',
};

export const IPSharedColors = {
  pinkRed10: '#750b1c',
  red20: '#a4262c',
  red10: '#d13438',
  redOrange20: '#603d30',
  redOrange10: '#da3b01',
  orange30: '#8e562e',
  orange20: '#ca5010',
  orange10: '#ffaa44',
  yellow10: '#fce100',
  orangeYellow20: '#986f0b',
  orangeYellow10: '#c19c00',
  yellowGreen10: '#8cbd18',
  green20: '#0b6a0b',
  green10: '#498205',
  greenCyan10: '#00ad56',
  cyan40: '#005e50',
  cyan30: '#005b70',
  cyan20: '#038387',
  cyan10: '#00b7c3',
  cyanBlue20: '#004e8c',
  cyanBlue10: '#0078d4',
  blue10: '#4f6bed',
  blueMagenta40: '#373277',
  blueMagenta30: '#5c2e91',
  blueMagenta20: '#8764b8',
  blueMagenta10: '#8378de',
  magenta20: '#881798',
  magenta10: '#c239b3',
  magentaPink20: '#9b0062',
  magentaPink10: '#e3008c',
  gray40: '#393939',
  gray30: '#7a7574',
  gray20: '#69797e',
  gray10: '#a0aeb2',
};
